// src/components/filter.
import React, { useMemo, useEffect, useState } from "react";
import PropTypes from 'prop-types';

//import components
import Breadcrumbs from 'components/Common/Breadcrumb';
import DataTable from "../../components/Common/LocalizedDataTable";
import { CategoryApi } from "apis/CategoryApi";
import { useHistory } from "react-router-dom"
import { withTranslation } from "react-i18next";
import i18n from "i18n";
import config from "config/config";
import { Link } from "react-router-dom";
import Swal from "../../helpers/swal_helper";
import { formatNumber } from "../../helpers/language_helper";
function Categories(props) {
    const history = useHistory();
    const [data, setdata] = useState([]);
    const [loading, setLoading] = useState(false);
    const [activeData, setActiveData] = useState({
        page: 1,
        totalPage: 1,
        search: "",
        limit: config.LIMIT,
    });

    useEffect(() => {
        getAllCategories(activeData);
    }, []);

    const columns = [{
        name: props.t("Sr.No"),
        selector: row => row.id,
        cell: row => formatNumber(row.id),
        sortable: true,
    }, {
        name: props.t("Name"),
        selector: row => row.name,
        sortable: true
    }, {
        name: props.t("Status"),
        selector: row => row.status === 1 ? props.t("Active") : props.t("Inactive"),
        sortable: true,
        cell: row => (
            <span style={{
                color: row.status === 1 ? '#28a745' : '#dc3545',
                fontWeight: '500'
            }}>
                {row.status === 1 ? props.t("Active") : props.t("Inactive")}
            </span>
        )
    }, {
        name: props.t("Action"),
        selector: row => row.action
    }];

    const getAllCategories = (data) => {
        setLoading(true);
        CategoryApi.getAllCategories(data)
            .then((res) => {
                if (res.data.status) {
                    setActiveData({
                        ...activeData,
                        totalPage: res.data.data.total,
                    });
                    let tableData = [];
                    res.data.data.categories.forEach((v, i) => {
                        tableData[i] = {
                            id: i+1,
                            name: v.name,
                            status: v.status,
                            action: (
                                <>
                                    <Link
                                        style={{ marginRight: "15px" }}
                                        to={`/edit-category/${v.id}`}
                                    >
                                        <i className="fas fa-edit" id="edittooltip" />
                                    </Link>
                                    <i className="mdi mdi-delete font-size-18" style={{ color: "red" }} id="deletetooltip" onClick={() => onDelete(v.id)} />
                                </>
                            ),
                        };
                    });
                    setdata(tableData);
                } else {
                    Swal.fire({
                        title: "Error",
                        text: res.data.message,
                        icon: "error",
                    });
                }
                setLoading(false);
            })
            .catch((err) => {
                console.log(err);
                setLoading(false);
                Swal.fire({
                    title: "Error",
                    text: "Failed to fetch categories",
                    icon: "error",
                });
            });
    };

    const onDelete = (id) => {
        Swal.fire({
            title: props.t("Are you sure?"),
            text: props.t("You won't be able to revert this!"),
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#f46a6a",
            confirmButtonText: props.t("Yes, delete it!"),
            cancelButtonText: props.t("Cancel")
        }).then((result) => {
            if (result.isConfirmed) {
                CategoryApi.deleteCategory(id)
                    .then((res) => {
                        if (res.data.status) {
                            Swal.fire("Deleted!", res.data.message, "success");
                            getAllCategories(activeData);
                        } else {
                            Swal.fire("Error!", res.data.message, "error");
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                        Swal.fire("Error!", "Failed to delete category", "error");
                    });
            }
        });
    };

    const handleChange = (page) => {
        const updatedData = { ...activeData, page };
        setActiveData(updatedData);
        getAllCategories(updatedData);
    }

    const handleRowChange = (limit) => {
        const updatedData = { ...activeData, limit };
        setActiveData(updatedData);
        getAllCategories(updatedData);
    }

    //meta title
    document.title = props.t("Service Category") + ' | ' + props.t("Salon");

    return (
        <div className="page-content">
            <div className="container-fluid">
                <Breadcrumbs title={props.t("Dashboard")} breadcrumbItem={props.t("Categories")} />
                <Link to="/add-category" className="btn btn-primary w-xs btn-right">{props.t("Add")}</Link>
            </div>

            <div className="container-fluid">
                <DataTable
                    className="table-bordered"
                    progressPending={loading}
                    columns={columns}
                    data={data}
                    pagination
                    paginationServer
                    paginationTotalRows={activeData.totalPage}
                    paginationPerPage={activeData.limit}
                    defaultSortFieldID={1}
                    onChangeRowsPerPage={value => handleRowChange(value)}
                    onChangePage={value => handleChange(value)}
                    sortable
                    noHeader
                    defaultSortField="id"
                    defaultSortAsc={false}
                    highlightOnHover
                />
            </div>
        </div>
    );
}
Categories.propTypes = {
    t: PropTypes.any,
    preGlobalFilteredRows: PropTypes.any,

};
export default withTranslation()(Categories);